<template>
    <App :isShow="true">
        <div>
            <div class="row px-0">
                <div class="col-sm-12 col-md-8 v-col-lg-9 text-center">
                    <h4 class="pt-3 text-start">លទ្ធផលស្វែងរក  <span class="text-warning">({{ countPosts}}) ៖ {{ search }}</span></h4>

                    <SubMenuSearch @onSearch="onSearchHandle" :searchShow="true"  :search="search" />

                    <div class="row g-4">
                        <NewsCardTile
                            v-if="slug==='news' || slug==='photos' || slug==='others'"
                            v-for="post in articles"
                            :id="post.id"
                            :title="post.title"
                            :first_name="post.first_name"
                            :last_name="post.last_name"
                            :image="post.image"
                            :category_name="post.category_name"
                            :category_slug="post.category_slug"
                            :created_at="post.created_at"
                            :short_description="post.meta_description"
                            :body="post.body"
                        />
                        <PdfCardTile
                            v-if="slug==='books' || slug==='documents'"
                            v-for="post in articles"
                            :id="post.id"
                            :title="post.title"
                            :first_name="post.first_name"
                            :last_name="post.last_name"
                            :image="post.image"
                            :category_name="post.category_name"
                            :category_slug="post.category_slug"
                            :created_at="post.created_at"
                        />
                        <AudioCardTile
                            v-if="slug==='audios'"
                            v-for="post in articles"
                            :id="post.id"
                            :title="post.title"
                            :first_name="post.first_name"
                            :last_name="post.last_name"
                            :image="post.image"
                            :category_name="post.category_name"
                            :category_slug="post.category_slug"
                            :created_at="post.created_at"
                            :format="post.format"
                            :link_url="post.link_url"
                        />

                        <VideoCardTile
                            v-if="slug==='videos'"
                            v-for="post in articles"
                            :id="post.id"
                            :title="post.title"
                            :first_name="post.first_name"
                            :last_name="post.last_name"
                            :image="post.image"
                            :category_name="post.category_name"
                            :category_slug="post.category_slug"
                            :created_at="post.created_at"
                            :body="post.body"
                            :format="post.format"
                            :link_url="post.link_url"
                        />
                    </div>
                    <div v-if="articles.length >= currentPage*12" class="fs-5 mt-3" @click="loadMore" role="button">
                        <span v-if="isLoading">មើលបន្ថែមទៀត...</span>
                        <span v-else>មើលបន្ថែមទៀត<i class="fa-solid fa-chevron-right fs-6"></i></span>
                    </div>
                    <div v-if="articles.length===0" class="text-center h-100">
                        <p class="text-grey ff-koulen fs-18 mt-5">
                            មិនមានលទ្ធផលដែលបានស្វែងរក
                        </p>
                    </div>
                </div>
                <div class="col-sm-12 col-md-4 v-col-lg-3">
                    <RightSideBar/>
                </div>
            </div>
        </div>
    </App>
</template>

<script setup>
import NewsCardTile from "../Components/NewsCardTile.vue";
import RightSideBar from "../Components/RightSideBar.vue";
import App from "../Layouts/App";
import {computed, ref} from "vue";
import axios from "axios";
import SubMenu from "../Components/Share/SubMenu.vue";
import {usePage} from "@inertiajs/vue3";
import VideoCardTile from "../Components/VideoCardTile.vue";
import PdfCardTile from "../Components/PdfCardTile.vue";
import AudioCardTile from "../Components/AudioCardTile.vue";
import {Inertia} from "@inertiajs/inertia";
import SubMenuSearch from "../Components/Share/SubMenuSearch.vue";

const props = defineProps({
    slug: String,
    posts: Array,
    search: String,
    searchShow: true,
    countPosts: Number
});

const articles = ref(props.posts);
const countPosts = ref(props.countPosts);
const currentPage = ref(1);
const isLoading = ref(false);
async function loadMore() {
    isLoading.value = true;
    const response = await axios.get(route('search.loadmore'), {
        params: {
            search: search,
            page: currentPage.value + 1
        },
    });
    isLoading.value = false
    const data = response.data.data;
    if (data?.length) {
        articles.value.push(...data);
    }
    currentPage.value++;
}
async function onSearchHandle(newSearch) {
    search.value = newSearch;
    await Inertia.visit('/search', {
        method: 'get',
        data: {
            search: newSearch,
        },
        preserveState: true,
        replace: true,
    });
}

</script>
